module.exports = "<p>\r\n  promo-code works!\r\n</p>\r\n"